export default "__VITE_ASSET__Q5lq1W7K__"